import type { ViewJobHint } from '../types/TareBridge';

import { getTareBridge } from './getTareBridge';
import { callPromiseSafely } from '../../util/callPromiseSafely';

/**
 * Set cached view job hint in the native module.
 */
export function setCachedViewJobHint(
    jobKey: string,
    viewJobHint: ViewJobHint,
): Promise<void | null> {
    return callPromiseSafely(() => {
        const bridge = getTareBridge();
        if (!bridge?.setCachedViewJobHint) {
            return Promise.resolve();
        }
        return bridge.setCachedViewJobHint(jobKey, viewJobHint);
    });
}
